import React from "react";
import Typography from "@material-ui/core/Typography";
import {OrderEngineStepActions} from "./OrderEngineStepActions";
import {FindAvailabilityStepProps} from "../types";
import {Address} from "../../redux/types";
import {DcbAddressInput} from "../../sharedComponents/DcbAddressInput";

export function AddressStep(props: FindAvailabilityStepProps<Address>) {

    const [selectedAddress, setSelectedAddress] = React.useState<Address | undefined>(props.initialValue);
    const [error, setError] = React.useState<null | string>(null);

    return (
        <div>
            <Typography color={"textSecondary"} style={{marginTop: 16, marginBottom: 8}}>Wo möchten Sie die Dienstleistung erledigt haben?</Typography>
            <DcbAddressInput
                label="Adresse"
                value={selectedAddress}
                onChange={(a) => {
                    setError(null);
                    if(a) {
                        if(a.formattedAddress === "") {
                            setError("darf nicht leer sein");
                        }
                        const posOfFirstComma = a.formattedAddress.indexOf(",");
                        const potentialNumber = a.formattedAddress.substring(posOfFirstComma - 1, posOfFirstComma);
                        if(isNaN(parseInt(potentialNumber))) {
                            setError("Bitte geben Sie eine Hausnummer ein")
                        }

                    }
                    setSelectedAddress(a ?? undefined);
                }}
            />
            {error &&
            <Typography variant="subtitle1" color="error">
                {error}
            </Typography>}
            <OrderEngineStepActions
                onClickNext={selectedAddress ? () => props.onNext(selectedAddress) : undefined}
                onClickBack={props.onBack}
                lastStep={false}
            />
        </div>
    )
}
